import React, { useMemo, useState } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Divider,
  DialogContent,
  Popover,
  List,
  Tooltip,
  ListItem,
  ListItemButton,
  ListItemText,
  Grid,
  Select,
  MenuItem,
  Checkbox,
  Button,
  DialogTitle,
  DialogActions,
  FormControl,
  Box as MuiBox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PrintIcon from "@mui/icons-material/Print";
import DownloadIcon from "@mui/icons-material/Download";
import SettingsIcon from "@mui/icons-material/Settings";
import { LoadingButton } from "@mui/lab";
import parse from "html-react-parser";

import { PdfViewer } from "../../../../components/PdfViewer";
import TemplateSelection from "../../../../components/TemplateSelection";
import PDFExport from "../../../../components/PDFExport";
import VitalAndAnthropometry from "./VitalAndAnthropometry/VitalAndAnthropometry";
import AppointmentSave from "../../../FrontDesk/AddAppointment/AddAppointment";
import SkeletonWrapper from "../../../../components/Skeleton/SkeletonWrapper";
import Menu from "@mui/material/Menu";

import {
  VisitCompletionTemplate,
  VisitCompletionTemplateMap,
} from "../OPDClinical.types";
import {
  VISIT_COMPLETION_TEMPLATE_MAP,
  REFERRAL_VISIT_COMPLETION_TEMPLATE_MAP,
} from "../OPDClinical.constants";
import {
  BIllING_TEMPLATE,
  PRESCRIPTION_REPORT_TEMPLATES,
  PRESCRIPTION_REPORT_TEMPLATES_44,
} from "../../../../shared/Data/ReportTemplates";
import BillingPDFExport from "../../../Report/BillingHtmlReport/BillingPDFExport";
import PrescriptionTemplateSelection from "../../../../components/PrescriptionTemplateSelection";
import VerticalPrescriptionTemplatePDFExport from "../../../Report/Priscription/VerticalPrescriptionTemplate/VerticalPrescriptionTemplatePDFExport";
import EmailIcon from "@mui/icons-material/Email";
import EmailSendDialogForOPD from "../../../../components/EmailDialog/EmailSendDialogForOPD";
import { ensureOpdSendTokens } from "../../../../hooks/useOpdWhatsApp";

interface OPDClinicalDialogsProps {
  // Common
  userContext: any;
  isLoading: boolean;
  setIsLoading: (val: boolean) => void;
  fullScreen: boolean;
  mdd: boolean;
  smd: boolean;

  // Prescription PDF
  openPrescription: any;
  handleClosePrescription: () => void;
  prescriptionPrintReportData: string;
  invoiceTitle: string;
  scroll: any;
  itemData: any;
  url: string;

  // Billing PDF
  openBilling: boolean;
  handleCloseInvoice: () => void;
  billingPrintReportData: string;
  billingTitle: string;
  billingurl: string;
  billingData: any;

  // Prescription HTML
  prescriptionHtml: string | null;
  handlePrint: () => void;
  printRef: any;

  // More Popover
  openMore: boolean;
  anchorEl: any;
  handleCloseMore: () => void;
  selectedOPD: any;
  fetchDetailedOpdforReport: (item: any, reportName: string) => Promise<any>;
  handleOpenDialog: () => void;
  generateToken: (data: any) => Promise<any>;
  handlePatientOpdWhatsApp: (item: any) => Promise<void>;
  handlePatientScheduleWhatsApp: (item: any) => Promise<void>;
  handleClickOpenBilling: (
    scroll: any,
    id: number,
    val: string,
    title: string,
    item: any,
  ) => void;
  handleOpenInvoiceReportSelctionDialogBox: (item: any) => void;
  handleGenerateBill: (item: any) => void;
  handleEditBilling: (item: any) => void;
  handleOpenOPDClinicDetail: (id: number) => void;
  handleCancel: (item: any) => void;

  // Appointment Dialog
  customPopUp: any;
  handleClosePopup: () => void;
  handleManagePopup: (code: string, company: any) => void;
  tabType: any;

  // Billing Template
  invoiceReportSelectionDialog: boolean;
  handleCloseInvoiceReportSelctionDialogBox: (val: any) => void;
  saveDefaultBilling: (name: string) => void;

  // Prescription Template
  templateSelectionPopUp: any;
  handleCloseTemplateSelection: () => void;
  prescriptionTemplates: any[];
  handleClickOpenPrescription: (scroll: any, item: any, name: string) => void;
  saveDefaultPrescription: (name: string) => void;

  // Auto Prescription
  isAutoPrescriptionPopUp: boolean;
  handleCloseAutoPrescription: () => void;
  isAutoPrescriptionChecked: boolean;
  setIsAutoPrescriptionChecked: (val: boolean) => void;
  handleAcceptAutoPrescription: () => void;

  // Prescription Report HTML5 (Settings/Zoom)
  openPrescriptionReport: boolean;
  handleCloseHTMLPopup: () => void;
  zoomLevel: number;
  handleZoomChange: (e: any) => void;
  zoomOptions: number[];
  handleZoomOut: () => void;
  handleZoomIn: () => void;
  handlePdfPrint: () => void;
  handlePDFDownload: () => void;
  handleSettingsOpen: (e: any) => void;
  menuAnchorEl: any;
  reportConfigData: any[];
  setReportConfigData: React.Dispatch<React.SetStateAction<any[]>>;
  handleSettingsSave: () => void;
  handleSettingsClose: () => void;
  htmlprintRef: any;
  detailedOpd: any;
  reportConfigDetail: any[];

  // WhatsApp
  openWhatsAppDialog: boolean;
  setOpenWhatsAppDialog: (val: boolean) => void;
  selectedWhatsappTemplateId: number | "";
  setSelectedWhatsappTemplateId: (id: number | "") => void;
  whatsappTemplates: any[];
  selectedWhatsappContext:
    | "PATIENT_OPD"
    | "REFERRAL_DOCTOR_OPD"
    | "PATIENT_SCHEDULED_OPD"
    | "PATIENT_WAITING_OPD"
    | null;
  setSelectedWhatsappContext: (
    context:
      | "PATIENT_OPD"
      | "REFERRAL_DOCTOR_OPD"
      | "PATIENT_SCHEDULED_OPD"
      | "PATIENT_WAITING_OPD"
      | null,
  ) => void;
  defaultWhatsappTemplates: any;
  handleUpdateDefaultWhatsappTemplate: (id: number | "", context: any) => void;
  whatsappPreviewMessage: string;
  selectedItem: any;
  setSelectedItem: (item: any) => void;
  sendVisitCompletionViaApi: (
    item: any,
    templateStyle: string,
    target?: "PATIENT" | "REF_DOCTOR",
  ) => Promise<void>;

  // Single-item "Select Visit Completion Style" dialog
  // (same dialog the bulk-send flow uses, reused for a single patient/referral-doctor send)
  singleSendItem: any | null;
  singleSendTarget: "PATIENT" | "REF_DOCTOR" | null;
  openSingleItemTemplateStyleDialog: (
    item: any,
    target: "PATIENT" | "REF_DOCTOR",
  ) => void;
  closeSingleItemTemplateStyleDialog: () => void;
  handleClickOnWhatsApp: (item: any) => Promise<void>;
  setMissingPhoneNames: (val: any[]) => void;
  openMissingNumberDialog: boolean;
  setOpenMissingNumberDialog: (val: boolean) => void;
  missingPhoneNames: any[];

  // Email
  openEmailDialog: boolean;
  setOpenEmailDialog: (val: boolean) => void;
  selectedEmailTemplateId: number | "";
  setSelectedEmailTemplateId: (id: number | "") => void;
  emailTemplates: any[];
  defaultEmailTemplateId: number | "";
  handleUpdateDefaultEmailTemplate: (id: number | "") => void;
  emailPreviewMessage: string;
  selectedDoctor: any;
  handleEmailSend: (item: any) => Promise<void>;

  // Missing Email
  openMissingEmailDialog: boolean;
  setOpenMissingEmailDialog: (val: boolean) => void;
  missingEmail: string[];

  // WhatsApp QR
  whatsappQr: any;
  handleCloseWhatsappQrPopup: () => void;

  // Vitals
  vitalsCustomPopUP: boolean;
  handleCloseVitalsCustomPopUp: (code: string, data: any) => void;
  opd: any;

  // Visit Completion Bulk
  openBulkTemplateDialog: boolean;
  setOpenBulkTemplateDialog: (val: boolean) => void;
  bulkTemplateSelection: string;
  setBulkTemplateSelection: (val: string) => void;
  handleBulkSend: (selectedType: string) => Promise<void>;
  bulkSendTarget: "PATIENT" | "REF_DOCTOR" | "BOTH";
  // Billing HTML
  openBillingPopupForHtml: (item: any, reportName: string) => Promise<any>;
  selectedValue: any;
  setSelectedValue: (value: any) => void;
  tempSelectedValue: any;
  setTempSelectedValue: (value: any) => void;
  openA4HtmlDialog: boolean;
  setOpenA4HtmlDialog: (val: boolean) => void;
  detailedBilling: any;
  setDetailedBilling: (value: any) => void;
  handleCloseBillingA4HtmlPopup: () => void;
  mainMenuEl: { for: string; target: any };
  setMainMenuEl: (value: { for: string; target: any }) => void;
  handleSettingsBillingA4HtmlOpen: (event: any, type: string) => void;
  handleSettingsBillingA4HtmlClose: () => void;
  billingReportConfigDetail: any[];
  setBillingReportConfigDetail: (value: any[]) => void;
  reportBillingConfigData: any[];
  setReportBillingConfigData: React.Dispatch<React.SetStateAction<any[]>>;
  handleBillingSettingsSave: () => void;
  openTemplateDialog: boolean;
  setOpenTemplateDialog: (val: boolean) => void;
  selectedPrescriptionTemplate: string;
  setSelectedPrescriptionTemplate: (val: string) => void;
  setSelectedReportTemplate: (val: string) => void;
  handleClickOpenPrescriptionReports: (
    scroll: any,
    item: any,
    reportName: string,
    closeDialog?: boolean,
  ) => Promise<void>;
  sendReferralDoctorViaApi: (item: any, typeKey: string) => Promise<void>;

  // Send Email Patient, Referral Doctor and Out Reach
  openSendEmailDialog: boolean;
  setOpenSendEmailDialog: (val: boolean) => void;
}

const OPDClinicalDialogs: React.FC<OPDClinicalDialogsProps> = (props) => {
  const {
    userContext,
    isLoading,
    setIsLoading,
    fullScreen,
    mdd,
    smd,
    openPrescription,
    handleClosePrescription,
    prescriptionPrintReportData,
    invoiceTitle,
    scroll,
    itemData,
    url,
    openBilling,
    handleCloseInvoice,
    billingPrintReportData,
    billingTitle,
    billingurl,
    billingData,
    prescriptionHtml,
    handlePrint,
    printRef,
    openMore,
    anchorEl,
    handleCloseMore,
    selectedOPD,
    fetchDetailedOpdforReport,
    handleOpenDialog,
    generateToken,
    handlePatientOpdWhatsApp,
    handlePatientScheduleWhatsApp,
    handleClickOpenBilling,
    handleOpenInvoiceReportSelctionDialogBox,
    handleGenerateBill,
    handleEditBilling,
    handleOpenOPDClinicDetail,
    handleCancel,
    customPopUp,
    handleClosePopup,
    handleManagePopup,
    tabType,
    invoiceReportSelectionDialog,
    handleCloseInvoiceReportSelctionDialogBox,
    saveDefaultBilling,
    templateSelectionPopUp,
    handleCloseTemplateSelection,
    prescriptionTemplates,
    handleClickOpenPrescription,
    saveDefaultPrescription,
    isAutoPrescriptionPopUp,
    handleCloseAutoPrescription,
    isAutoPrescriptionChecked,
    setIsAutoPrescriptionChecked,
    handleAcceptAutoPrescription,
    openPrescriptionReport,
    handleCloseHTMLPopup,
    zoomLevel,
    handleZoomChange,
    zoomOptions,
    handleZoomOut,
    handleZoomIn,
    handlePdfPrint,
    handlePDFDownload,
    handleSettingsOpen,
    menuAnchorEl,
    reportConfigData,
    setReportConfigData,
    handleSettingsSave,
    handleSettingsClose,
    htmlprintRef,
    detailedOpd,
    reportConfigDetail,
    openWhatsAppDialog,
    setOpenWhatsAppDialog,
    selectedWhatsappTemplateId,
    setSelectedWhatsappTemplateId,
    whatsappTemplates,
    selectedWhatsappContext,
    setSelectedWhatsappContext,
    defaultWhatsappTemplates,
    handleUpdateDefaultWhatsappTemplate,
    whatsappPreviewMessage,
    selectedItem,
    setSelectedItem,
    sendVisitCompletionViaApi,
    singleSendItem,
    singleSendTarget,
    openSingleItemTemplateStyleDialog,
    closeSingleItemTemplateStyleDialog,
    handleClickOnWhatsApp,
    setMissingPhoneNames,
    openMissingNumberDialog,
    setOpenMissingNumberDialog,
    missingPhoneNames,
    openEmailDialog,
    setOpenEmailDialog,
    selectedEmailTemplateId,
    setSelectedEmailTemplateId,
    emailTemplates,
    defaultEmailTemplateId,
    handleUpdateDefaultEmailTemplate,
    emailPreviewMessage,
    selectedDoctor,
    handleEmailSend,
    openMissingEmailDialog,
    setOpenMissingEmailDialog,
    missingEmail,
    whatsappQr,
    handleCloseWhatsappQrPopup,
    vitalsCustomPopUP,
    handleCloseVitalsCustomPopUp,
    opd,
    openBulkTemplateDialog,
    setOpenBulkTemplateDialog,
    bulkTemplateSelection,
    setBulkTemplateSelection,
    handleBulkSend,
    bulkSendTarget,
    openBillingPopupForHtml,
    selectedValue,
    setSelectedValue,
    tempSelectedValue,
    setTempSelectedValue,
    openA4HtmlDialog,
    setOpenA4HtmlDialog,
    detailedBilling,
    setDetailedBilling,
    handleCloseBillingA4HtmlPopup,
    mainMenuEl,
    setMainMenuEl,
    handleSettingsBillingA4HtmlOpen,
    handleSettingsBillingA4HtmlClose,
    billingReportConfigDetail,
    setBillingReportConfigDetail,
    reportBillingConfigData,
    setReportBillingConfigData,
    handleBillingSettingsSave,
    openTemplateDialog,
    setOpenTemplateDialog,
    selectedPrescriptionTemplate,
    setSelectedPrescriptionTemplate,
    setSelectedReportTemplate,
    handleClickOpenPrescriptionReports,
    sendReferralDoctorViaApi,
    openSendEmailDialog,
    setOpenSendEmailDialog,
  } = props;

  const [emailOpd, setEmailOpd] = useState<any>(null);

  const isVertical21cm = selectedPrescriptionTemplate === "Vertical21cm";

  const activeTemplateMap =
    (singleSendItem ? singleSendTarget : bulkSendTarget) === "REF_DOCTOR"
      ? REFERRAL_VISIT_COMPLETION_TEMPLATE_MAP
      : VISIT_COMPLETION_TEMPLATE_MAP;
  // Constant for Billing templates (moved from main file or kept here)
  // const BIllING_TEMPLATE = [
  //   { label: "Standard", value: "BillingInvoiceA4" },
  //   { label: "Thermal", value: "BillingInvoiceThermal" },
  // ];
  const whatsappScheduledConfig = useMemo(
    () =>
      userContext?.systemConfigurationDetailColl?.find(
        (i) =>
          i.configModule === "WHATSAPP_CONFIG" &&
          i.configKey === "APPOINTMENT_SCHEDULE_REMINDER",
      ),
    [userContext?.systemConfigurationDetailColl],
  );
  const whatsappComplatedConfig = useMemo(
    () =>
      userContext?.systemConfigurationDetailColl?.find(
        (i) =>
          i.configModule === "WHATSAPP_CONFIG" &&
          i.configKey === "CONSULTATION_CHECK_OUT",
      ),
    [userContext?.systemConfigurationDetailColl],
  );
  return (
    <>
      {openPrescription.open && openPrescription.type === "PRESCRIPTION" && (
        <PdfViewer
          openInvoice={
            openPrescription.open && openPrescription.type === "PRESCRIPTION"
          }
          handleCloseInvoice={handleClosePrescription}
          invoiceHtmlTitle={"Prescription"}
          invoiceHtml={prescriptionPrintReportData}
          invoiceTitle={invoiceTitle}
          fileUrl={url}
          itemData={itemData}
        />
      )}

      {openBilling && (
        <PdfViewer
          openInvoice={openBilling}
          handleCloseInvoice={handleCloseInvoice}
          invoiceHtmlTitle={"Billing Invoice"}
          invoiceHtml={billingPrintReportData}
          invoiceTitle={billingTitle}
          fileUrl={billingurl}
          itemData={billingData}
        />
      )}

      <Dialog
        className="dialog"
        open={
          openPrescription.open && openPrescription.type === "HTML_PRESCRIPTION"
        }
        onClose={handleClosePrescription}
        scroll="paper"
        fullScreen
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        sx={{
          ".MuiDialog-paper": { width: "fit-content", padding: "16px" },
          width: "fit-content",
          minHeight: "90vh",
        }}
      >
        <AppBar position="static" sx={{ background: "#f5f5f5", color: "#000" }}>
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <Typography variant="h6">Prescription</Typography>
            <Box>
              <IconButton onClick={handlePrint}>
                <LocalPrintshopIcon />
              </IconButton>
              <IconButton onClick={handleClosePrescription}>
                <CloseIcon color="error" />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        <DialogContent
          style={{ padding: 0, background: "#fff !important", width: "100%" }}
        >
          <Box
            sx={{
              padding: 2,
              backgroundColor: "var(--opd-input-bg, #f9f9f9)",
              width: "100%",
              "@media print": {
                "-webkit-print-color-adjust": "exact",
                "print-color-adjust": "exact",
                "*": { background: "inherit !important" },
              },
            }}
            ref={printRef}
          >
            {parse(prescriptionHtml || "")}
          </Box>
        </DialogContent>
      </Dialog>

      <Popover
        elevation={1}
        open={openMore}
        anchorEl={anchorEl}
        onClose={handleCloseMore}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          "& .MuiPopover-paper": {
            border: "1px solid var(--opd-border-color, #ced4da)",
            borderRadius: "5px",
          },
        }}
      >
        <List>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              alignItems: "center",
              px: "16px",
              py: "8px",
            }}
          >
            {selectedOPD?.opdId > 0 && (
              <>
                <Tooltip title={"Print Prescription"} placement="top">
                  <IconButton
                    onClick={async () => {
                      const defaultTemplate =
                        userContext?.defaultPrescriptionTemplate ||
                        "Prescription";
                      setSelectedReportTemplate(defaultTemplate);
                      setSelectedPrescriptionTemplate(defaultTemplate);
                      const data = await fetchDetailedOpdforReport(
                        selectedOPD,
                        defaultTemplate,
                      );
                      if (!!data) {
                        handleOpenDialog();
                      }
                      handleCloseMore();
                    }}
                    sx={{ margin: 0, padding: 0, color: "red" }}
                  >
                    <img
                      src="prescription_24.svg"
                      alt="Print Prescription"
                      className="pdf-icon-hover opd-print-prescription-icon"
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title={"Select Prescription Template"} placement="top">
                  <IconButton
                    color="primary"
                    onClick={() => {
                      setOpenTemplateDialog(true);
                      handleCloseMore();
                    }}
                    sx={{ cursor: "pointer", marginLeft: "-8px", padding: 0 }}
                  >
                    <KeyboardArrowDownIcon color="secondary" />
                  </IconButton>
                </Tooltip>

                {whatsappComplatedConfig?.configValue === "1" && (
                  <Tooltip title={"Send WhatsApp"}>
                    <IconButton
                      color="secondary"
                      onClick={async () => {
                        setIsLoading(true);
                        const currOPD = await ensureOpdSendTokens(
                          selectedOPD,
                          generateToken,
                          [
                            "prescription",
                            "fullPrescription",
                            "growthChart",
                            "billing",
                          ],
                        );
                        setIsLoading(false);
                        handleCloseMore();
                        await handlePatientOpdWhatsApp(currOPD);
                      }}
                      sx={{ cursor: "pointer", margin: 0, padding: 0 }}
                    >
                      <WhatsAppIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                )}
              </>
            )}
            {selectedOPD?.billingId > 0 && (
              <Box sx={{ display: "flex", alignItems: "center", p: 0, m: 0 }}>
                <Tooltip title={"Print Bill"} placement="top">
                  <ReceiptLongRoundedIcon
                    fontSize="large"
                    sx={{
                      cursor: "pointer",
                      margin: 0,
                      padding: 0,
                      height: "26px",
                      width: "26px",
                    }}
                    onClick={() => {
                      handleClickOpenBilling(
                        "paper",
                        selectedOPD.billingId,
                        "0",
                        "Billing",
                        selectedOPD,
                      );
                    }}
                  />
                </Tooltip>
                <Tooltip title={"Select Bill Templete"} placement="top">
                  <IconButton
                    color="primary"
                    onClick={() =>
                      handleOpenInvoiceReportSelctionDialogBox(selectedOPD)
                    }
                    sx={{ cursor: "pointer", margin: 0, padding: 0 }}
                  >
                    <KeyboardArrowDownIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            {/* Send Email Patient, Referral Doctor and Out Reach */}
            <Tooltip title="Send Email" placement="top">
              <IconButton
                onClick={async () => {
                  setIsLoading(true);
                  const enriched = await ensureOpdSendTokens(
                    selectedOPD,
                    generateToken,
                    ["prescription", "fullPrescription", "billing"],
                  );
                  setEmailOpd(enriched);
                  setIsLoading(false);
                  setOpenSendEmailDialog(true);
                  handleCloseMore();
                }}
              >
                <EmailIcon />
              </IconButton>
            </Tooltip>
            {selectedOPD?.caseStatus === "SCHEDULED" &&
              whatsappScheduledConfig?.configValue === "1" && (
                <Tooltip
                  title={"Send WhatsApp message to the scheduled patient"}
                  placement="top"
                >
                  {/* <IconButton
                  color="primary"
                  onClick={async () => {
                    setOpenWhatsAppDialog(true);
                    setSelectedWhatsappContext("PATIENT_SCHEDULED_OPD");
                    setSelectedWhatsappTemplateId(
                      defaultWhatsappTemplates.PATIENT_SCHEDULED_OPD || "",
                    );
                    setSelectedItem(selectedOPD);
                  }}
                >
                  <WhatsAppIcon />
                </IconButton> */}
                  <IconButton
                    color="primary"
                    onClick={async () => {
                      const currOPD = selectedOPD;
                      handleCloseMore();
                      await handlePatientScheduleWhatsApp(currOPD);
                    }}
                  >
                    <WhatsAppIcon />
                  </IconButton>
                </Tooltip>
              )}
            {selectedOPD?.caseStatus === "WAITING" && (
              <Tooltip
                title={"Send WhatsApp message to the waiting patient"}
                placement="top"
              >
                <IconButton
                  color="primary"
                  onClick={async () => {
                    setOpenWhatsAppDialog(true);
                    setSelectedWhatsappContext("PATIENT_WAITING_OPD");
                    setSelectedWhatsappTemplateId(
                      defaultWhatsappTemplates.PATIENT_WAITING_OPD || "",
                    );
                    setSelectedItem(selectedOPD);
                  }}
                >
                  <WhatsAppIcon />
                </IconButton>
              </Tooltip>
            )}
          </Box>
          {selectedOPD?.caseStatus === "COMPLETE" &&
            selectedOPD?.billingId <= 0 && (
              <Grid item xs={12}>
                <Divider />
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      handleGenerateBill(selectedOPD);
                    }}
                  >
                    <ListItemText primary="Generate Bill" />
                  </ListItemButton>
                </ListItem>
              </Grid>
            )}
          {selectedOPD?.billingId > 0 && (
            <Grid item xs={12}>
              <Divider />
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => {
                    handleEditBilling(selectedOPD);
                  }}
                >
                  <ListItemText primary="Edit Bill" />
                </ListItemButton>
              </ListItem>
            </Grid>
          )}
          {selectedOPD?.opdId > 0 && (
            <Grid item xs={12}>
              <Divider />
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => {
                    handleOpenOPDClinicDetail(selectedOPD?.opdId || 0);
                  }}
                >
                  <ListItemText primary="Edit" />
                </ListItemButton>
              </ListItem>
            </Grid>
          )}
          {selectedOPD?.opdId <= 0 && (
            <Grid item xs={12}>
              <Divider />
              <ListItem disablePadding>
                <ListItemButton
                  className="delete-container"
                  onClick={() => {
                    handleCancel(selectedOPD);
                  }}
                >
                  Cancel
                </ListItemButton>
              </ListItem>
            </Grid>
          )}
        </List>
      </Popover>

      <Dialog
        className="dialogPage"
        open={customPopUp.open && customPopUp.code === "APPOINTMENT"}
        onClose={(e, reason) => {
          if (reason !== "backdropClick") {
            handleClosePopup();
          }
        }}
        fullScreen
        PaperProps={{
          style: { width: "1200px", height: "700px", maxWidth: "none" },
        }}
      >
        <AppBar sx={{ position: "relative", width: "100%" }}>
          <Toolbar>
            <Box
              sx={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{ fontWeight: 600, marginLeft: 0 }}
                sx={{ ml: 2, flex: 1 }}
                variant="h6"
              >
                Update Appointment
              </Typography>
              <IconButton onClick={handleClosePopup}>
                <CloseRoundedIcon />
              </IconButton>
            </Box>
          </Toolbar>
          <Grid item xs={12}>
            <Divider />
          </Grid>
        </AppBar>
        <DialogContent sx={{ padding: "12px 24px" }}>
          <AppointmentSave
            handleClosePopUp={(code: string, company: any) => {
              handleManagePopup(code, company);
            }}
            opd={customPopUp.opd}
            isForPopUp={customPopUp.open}
            tabType={tabType}
          />
        </DialogContent>
        <Divider />
      </Dialog>

      <Dialog
        className="billing-template-dialog"
        fullScreen={fullScreen}
        open={invoiceReportSelectionDialog}
        onClose={() => handleCloseInvoiceReportSelctionDialogBox(null)}
        scroll={"paper"}
        PaperProps={{ style: { width: "350px", maxWidth: "none" } }}
      >
        <DialogTitle
          className="scroll-dialog-title-container"
          sx={{ paddingBottom: "0px !important" }}
        >
          <Grid container className="head-dialog-box-container">
            <Grid item xs={11}>
              <Typography className="bold-600 font-size-24">
                Billing Template
              </Typography>
              <Typography> Select Your Billing Template</Typography>
            </Grid>
            <Grid item xs={1} sx={{ paddingTop: "2px" }}>
              <Tooltip title={"Close"} placement="top">
                <IconButton
                  aria-label="close"
                  onClick={() =>
                    handleCloseInvoiceReportSelctionDialogBox(null)
                  }
                  style={{ marginTop: "-10px !important" }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent
          sx={{
            padding: "8px 20px 12px 20px !important",
            overflowY: "visible !important",
          }}
        >
          <Box>
            <TemplateSelection
              templates={BIllING_TEMPLATE}
              defaultTemplate={
                userContext?.defaultBillingTemplate || "BillingInvoiceA4"
              }
              handleTemplateClick={async (item: any) => {
                if (item?.value === "BillingInvoiceA4HTML") {
                  const data = await openBillingPopupForHtml(
                    selectedOPD,
                    "BillingInvoiceA4HTML",
                  );

                  if (data) {
                    setOpenA4HtmlDialog(true);
                  }
                } else {
                  handleClickOpenBilling(
                    "paper",
                    selectedOPD.billingId,
                    "0",
                    "Billing",
                    selectedOPD,
                  );
                }
              }}
              setDefaultTemplate={(item: any) => {
                saveDefaultBilling(item);
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={
          templateSelectionPopUp.open &&
          templateSelectionPopUp.type === "PRESCRIPTION"
        }
        onClose={handleCloseTemplateSelection}
        scroll={"paper"}
      >
        <DialogTitle
          className="scroll-dialog-title-container"
          sx={{ paddingBottom: "0px !important" }}
        >
          <Grid container className="head-dialog-box-container">
            <Grid item xs={11}>
              <Typography className="bold-600 font-size-24">
                Prescription Template
              </Typography>
              <Typography> Select Your Prescription Template</Typography>
            </Grid>
            <Grid item xs={1} sx={{ paddingTop: "2px" }}>
              <Tooltip title={"Close"} placement="top">
                <IconButton
                  aria-label="close"
                  onClick={handleCloseTemplateSelection}
                  style={{ marginTop: "-10px !important" }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent
          style={{ padding: "8px 0px 12px 20px", marginRight: "25px" }}
        >
          <Box>
            <TemplateSelection
              templates={prescriptionTemplates}
              defaultTemplate={userContext.defaultPrescriptionTemplate}
              handleTemplateClick={(template: any) => {
                handleClickOpenPrescription(
                  "paper",
                  selectedOPD,
                  template?.value || "",
                );
              }}
              setDefaultTemplate={(item: any) => {
                saveDefaultPrescription(item);
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        className="dialogPage"
        open={isAutoPrescriptionPopUp}
        onClose={(e, reason) => {
          if (reason !== "backdropClick" && isAutoPrescriptionPopUp) {
            handleCloseAutoPrescription();
          }
        }}
        fullScreen={smd}
      >
        <DialogContent>
          <Grid container gap={2}>
            <Grid item xs={12}>
              <Typography variant="h6" fontWeight="bold">
                Accept Terms & Conditions
              </Typography>
              <Typography variant="body2" color="textSecondary">
                You must accept the terms and conditions to proceed.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ height: smd ? "auto" : "350px", overflow: "auto" }}>
                <List component="ol" sx={{ listStyleType: "decimal", pl: 3 }}>
                  <ListItem sx={{ display: "list-item" }}>
                    <Typography>
                      Dosage calculation given by the Vistamed Weight/Body
                      Surface Area Based Dose Calculator system is provided for
                      educational, academic and guidance purposes only...
                    </Typography>
                  </ListItem>
                  <ListItem sx={{ display: "list-item" }}>
                    <Typography>
                      Value of the Dosage that user is getting after application
                      of Vistamed Weight / Body Surface Area based Dose
                      calculation system depends on many factors...
                    </Typography>
                  </ListItem>
                </List>
              </Box>
            </Grid>
            <Grid item xs={12} sx={{ width: "100%" }}>
              <Box
                sx={{
                  px: 2,
                  width: "100%",
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  checked={isAutoPrescriptionChecked}
                  onChange={(e) => {
                    setIsAutoPrescriptionChecked(e.target.checked);
                  }}
                />
                <Typography
                  display="inline"
                  variant="body2"
                  onClick={() =>
                    setIsAutoPrescriptionChecked(!isAutoPrescriptionChecked)
                  }
                  sx={{ cursor: "pointer" }}
                >
                  I agree to the Terms & Conditions
                </Typography>
              </Box>
              <Box
                sx={{
                  px: 2,
                  gap: 2,
                  width: "100%",
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!isAutoPrescriptionChecked}
                  onClick={handleAcceptAutoPrescription}
                >
                  Accept
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleCloseAutoPrescription}
                >
                  Cancel
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={openPrescriptionReport}
        onClose={handleCloseHTMLPopup}
        scroll="paper"
        disableEnforceFocus
        disableAutoFocus
        className="print-preview-dialog"
        PaperProps={{
          sx: {
            borderRadius: "4px",
            maxWidth: "950px",
            padding: "0px",
            margin: "0px",
            overflow: "hidden",
            backgroundColor: "var(--opd-panel-bg, #fff)",
          },
        }}
      >
        <DialogTitle
          className="print-preview-dialog-title"
          sx={{
            borderBottom: "1px solid var(--opd-border-color, #ddd)",
            padding: "4px 16px",
            backgroundColor: "var(--opd-header-bg, #fff)",
            color: "var(--opd-panel-fg, inherit)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              gap={0}
              sx={{ padding: 0, margin: 0 }}
            >
              <Select
                value={zoomLevel}
                onChange={handleZoomChange}
                sx={{
                  mx: 1,
                  minWidth: 70,
                  border: "none",
                  color: "var(--opd-panel-fg, inherit)",
                  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& .MuiSelect-icon": {
                    color: "var(--opd-panel-fg, inherit)",
                  },
                  backgroundColor: "transparent",
                  padding: 0,
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      border: "1px solid var(--opd-border-color, #c7c5c5)",
                      borderRadius: "4px",
                      backgroundColor: "var(--opd-panel-bg, #fff)",
                    },
                  },
                }}
              >
                {zoomOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    <Typography sx={{ fontSize: "13px !important" }}>
                      {(option * 100).toFixed(0)}%
                    </Typography>
                  </MenuItem>
                ))}
              </Select>
              <Box display="flex" gap={1}>
                <Tooltip title="Zoom Out">
                  <IconButton
                    onClick={handleZoomOut}
                    disabled={zoomLevel <= 0.25}
                    sx={{ padding: 0 }}
                  >
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Zoom In">
                  <IconButton
                    onClick={handleZoomIn}
                    disabled={zoomLevel >= 2}
                    sx={{ padding: 0 }}
                  >
                    <AddCircleOutlineIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
            <Box display="flex" justifyContent="flex-start" alignItems="center">
              <Tooltip title="Print PDF" placement="top">
                <IconButton aria-label="Print PDF" onClick={handlePdfPrint}>
                  <PrintIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Download PDF" placement="top">
                <IconButton
                  aria-label="Download PDF"
                  onClick={handlePDFDownload}
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
              <Box>
                <Tooltip title="Settings" placement="top">
                  <IconButton
                    aria-label="Settings"
                    onClick={handleSettingsOpen}
                  >
                    <SettingsIcon />
                  </IconButton>
                </Tooltip>
                <Menu
                  anchorEl={menuAnchorEl}
                  open={Boolean(menuAnchorEl)}
                  onClose={handleSettingsClose}
                >
                  <Box
                    sx={{
                      border: "1px solid #c7c5c5",
                      borderRadius: "4px",
                      backgroundColor: "var(--opd-panel-bg)",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "#dee6fa",
                        color: "#404d54",
                        padding: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      Settings
                    </Box>
                    <Box sx={{ width: "270px" }}>
                      {reportConfigData?.map((item: any, index: number) => (
                        <MenuItem
                          key={index}
                          sx={{ alignItems: "start", paddingLeft: "5px" }}
                          onClick={() => {
                            setReportConfigData((prev) =>
                              prev.map((x) =>
                                x.configKey === item?.configKey
                                  ? { ...x, isChecked: !item?.isChecked }
                                  : x,
                              ),
                            );
                          }}
                        >
                          <Checkbox
                            checked={item?.isChecked}
                            sx={{ padding: 0, margin: 0 }}
                          />
                          <Typography
                            sx={{
                              fontSize: "13px !important",
                              fontWeight: "normal",
                              paddingLeft: "8px",
                            }}
                          >
                            {item?.configKeyLabel}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        borderTop: "1px solid #ccc",
                        px: 2,
                        py: 1,
                        gap: "5px",
                      }}
                    >
                      <Button
                        size="small"
                        onClick={handleSettingsSave}
                        color="primary"
                        variant="contained"
                      >
                        Save
                      </Button>
                      <Button onClick={handleSettingsClose} size="small">
                        Close
                      </Button>
                    </Box>
                  </Box>
                </Menu>
              </Box>
              <Tooltip title="Close" placement="top">
                <IconButton aria-label="close" onClick={handleCloseHTMLPopup}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent
          className="print-preview-dialog-content"
          sx={{
            height: "100%",
            padding: "16px !important",
            fontFamily: "Arial, sans-serif",
            backgroundColor: "var(--print-preview-desk, #f1f3f5)",
            boxSizing: "border-box",
          }}
        >
          <Box
            className="print-preview-paper"
            sx={{
              width: "max-content",
              border: "1px solid #ddd",
              boxShadow: "4px rgba(0, 0, 0, 0.2)",
              borderRadius: "2px",
              // padding: "30px 50px",
              padding: isVertical21cm ? "7.5cm 2cm 2cm 1.2cm" : "30px 50px",
              fontFamily: "Arial, sans-serif",
              // Always white paper for print preview (theme must not invert this)
              backgroundColor: "#ffffff",
              color: "#111111",
              boxSizing: "border-box",
              transform: `scale(${zoomLevel})`,
              transformOrigin: "center",
              transition: "transform 0.2s ease-in-out",
            }}
          >
            <Box ref={htmlprintRef} sx={{ width: "794px" }}>
              {selectedPrescriptionTemplate === "Prescription" ? (
                <PDFExport
                  opdData={detailedOpd}
                  selectedSections={reportConfigDetail?.reduce(
                    (acc: any, item: any) => {
                      acc[item.configKey] = item.isChecked;
                      return acc;
                    },
                    {},
                  )}
                />
              ) : (
                <VerticalPrescriptionTemplatePDFExport
                  opdData={detailedOpd}
                  selectedReportTemplate={selectedPrescriptionTemplate}
                  selectedSections={reportConfigDetail?.reduce(
                    (acc: any, item: any) => {
                      acc[item.configKey] = item.isChecked;
                      return acc;
                    },
                    {},
                  )}
                />
              )}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        className="whatsapp-template-dialog"
        open={openWhatsAppDialog}
        onClose={() => setOpenWhatsAppDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>WhatsApp Template</DialogTitle>
        <DialogContent
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          <FormControl fullWidth>
            <Select className="whatsapp-template-select"
              value={selectedWhatsappTemplateId}
              onChange={(e) =>
                setSelectedWhatsappTemplateId(Number(e.target.value))
              }
              displayEmpty
            >
              <MenuItem value="" disabled>
                Select Template
              </MenuItem>
              {whatsappTemplates
                .filter(
                  (template) =>
                    template.templateFor?.toUpperCase() ===
                    selectedWhatsappContext?.toUpperCase(),
                )
                .map((template) => (
                  <MenuItem
                    key={template.notificationTemplateId}
                    value={template.notificationTemplateId}
                  >
                    {template.templateName}
                    {template.notificationTemplateId ===
                      defaultWhatsappTemplates[selectedWhatsappContext!] &&
                      " (Default)"}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          {selectedWhatsappTemplateId &&
            selectedWhatsappTemplateId !==
              defaultWhatsappTemplates[selectedWhatsappContext!] && (
              <Button
                onClick={() =>
                  handleUpdateDefaultWhatsappTemplate(
                    selectedWhatsappTemplateId,
                    selectedWhatsappContext,
                  )
                }
                variant="outlined"
                color="primary"
                size="small"
                sx={{ alignSelf: "flex-start" }}
              >
                Set as Default
              </Button>
            )}
          <Box className="whatsapp-template-preview"
            sx={{
              padding: 2,
              border: "1px solid #ccc",
              borderRadius: 2,
              backgroundColor: "var(--opd-input-bg, #f9f9f9)",
              minHeight: 100,
            }}
          >
            <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
              {parse(whatsappPreviewMessage || "Loading preview...")}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            loading={isLoading}
            onClick={async () => {
              const patientMobile = selectedItem?.patientPrimaryMobileNumber;
              const referredDoctorMobile =
                selectedItem?.referenceByDoctorPrimaryMobileName;
              let mobileToSend =
                selectedWhatsappContext === "PATIENT_OPD"
                  ? patientMobile
                  : selectedWhatsappContext === "REFERRAL_DOCTOR_OPD"
                    ? referredDoctorMobile
                    : patientMobile;
              if (!mobileToSend) {
                setMissingPhoneNames([
                  {
                    name:
                      selectedWhatsappContext === "REFERRAL_DOCTOR_OPD"
                        ? selectedItem?.referredByName || "Unknown"
                        : selectedItem?.patientName || "Unknown",
                    label:
                      selectedWhatsappContext === "REFERRAL_DOCTOR_OPD"
                        ? "Referred Doctor"
                        : "Patient",
                  },
                ]);
                setOpenMissingNumberDialog(true);
                return;
              }
              setIsLoading(true);
              if (
                (selectedWhatsappContext === "PATIENT_OPD" ||
                  selectedWhatsappContext === "REFERRAL_DOCTOR_OPD") &&
                (userContext?.waModuleType === "VISTAMED" ||
                  userContext?.waModuleType === "CLINIC_API")
              ) {
                setIsLoading(false);
                setOpenWhatsAppDialog(false);
                openSingleItemTemplateStyleDialog(
                  selectedItem,
                  selectedWhatsappContext === "REFERRAL_DOCTOR_OPD"
                    ? "REF_DOCTOR"
                    : "PATIENT",
                );
                return;
              }
              const templateFor =
                selectedWhatsappContext === "PATIENT_OPD"
                  ? "OPD_PATIENT"
                  : "OPD_REFERRAL_DOCTOR";
              await handleClickOnWhatsApp({
                ...selectedItem,
                targetMobile: mobileToSend,
                templateFor: templateFor,
              });
              setIsLoading(false);
              setOpenWhatsAppDialog(false);
            }}
            color="primary"
            variant="contained"
          >
            Send
          </LoadingButton>
          <Button onClick={() => setOpenWhatsAppDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openMissingNumberDialog}
        onClose={() => setOpenMissingNumberDialog(false)}
      >
        <DialogTitle>Reminder Not Sent</DialogTitle>
        <DialogContent dividers>
          {missingPhoneNames.length > 0 && (
            <>
              <Typography gutterBottom>
                WhatsApp could not be sent because the following contact(s) do
                not have a mobile number:
              </Typography>
              <Box sx={{ mt: 2, paddingLeft: "20px" }}>
                <ul>
                  {missingPhoneNames.map((entry, index) => (
                    <li key={"missing_phone_" + index}>
                      <Typography variant="body2">
                        <strong>{entry.label}:</strong> {entry.name}
                      </Typography>
                    </li>
                  ))}
                </ul>
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenMissingNumberDialog(false)}
            color="primary"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEmailDialog}
        onClose={() => setOpenEmailDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Email Template</DialogTitle>
        <DialogContent
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          <FormControl fullWidth>
            <Select
              value={selectedEmailTemplateId}
              onChange={(e) =>
                setSelectedEmailTemplateId(Number(e.target.value))
              }
              displayEmpty
            >
              {emailTemplates.map((template) => (
                <MenuItem
                  key={template.notificationTemplateId}
                  value={template.notificationTemplateId}
                >
                  {template.templateName}
                  {template.notificationTemplateId === defaultEmailTemplateId &&
                    " (Default)"}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {selectedEmailTemplateId &&
            selectedEmailTemplateId !== defaultEmailTemplateId && (
              <Button
                onClick={() =>
                  handleUpdateDefaultEmailTemplate(selectedEmailTemplateId)
                }
                variant="outlined"
                color="primary"
                size="small"
                sx={{ alignSelf: "flex-start" }}
              >
                Set as Default
              </Button>
            )}
          <Box className="whatsapp-template-preview"
            sx={{
              padding: 2,
              border: "1px solid #ccc",
              borderRadius: 2,
              backgroundColor: "var(--opd-input-bg, #f9f9f9)",
              minHeight: 100,
            }}
          >
            <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
              {parse(emailPreviewMessage || "Loading preview...")}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={async () => {
              if (!selectedDoctor) return;
              await handleEmailSend(selectedDoctor);
              setOpenEmailDialog(false);
            }}
            color="primary"
            variant="contained"
          >
            Send
          </Button>
          <Button onClick={() => setOpenEmailDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openMissingEmailDialog}
        onClose={() => setOpenMissingEmailDialog(false)}
      >
        <DialogTitle>Reminder Not Sent</DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom sx={{ mt: 2 }}>
            Email could not be sent because the referred doctor does not have an
            email address.
          </Typography>
          <MuiBox sx={{ mt: 2, paddingLeft: "20px" }}>
            <ul>
              {missingEmail.map((name, index) => (
                <li key={index}>
                  <Typography variant="body2">{name}</Typography>
                </li>
              ))}
            </ul>
          </MuiBox>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenMissingEmailDialog(false)}
            color="primary"
            variant="contained"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={whatsappQr.open}
        onClose={handleCloseWhatsappQrPopup}
        fullScreen={mdd}
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography>Scan the QR code to login</Typography>
            <IconButton onClick={handleCloseWhatsappQrPopup}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} md={8} sx={{ height: "100%" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box>
                  {[
                    "Open WhatsApp on your phone",
                    "On Android tap Menu ? ? On iPhone tap Settings ??",
                    "Tap Linked devices, then Link device",
                    "Scan the QR code to confirm",
                  ].map((step, idx) => (
                    <Box key={idx} display="flex" alignItems="flex-start">
                      <Box
                        width={24}
                        height={24}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        fontSize={14}
                        mr={2}
                      >
                        {idx + 1}.
                      </Box>
                      <Typography>{step}</Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <SkeletonWrapper
                isLoading={isLoading}
                className="skeleton-qr-box"
              >
                <Box
                  sx={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {whatsappQr.qr && (
                    <img
                      src={whatsappQr.qr}
                      alt="WhatsApp QR Code"
                      style={{ maxWidth: "100%", objectFit: "contain" }}
                    />
                  )}
                </Box>
              </SkeletonWrapper>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <Dialog
        className="dialog"
        open={vitalsCustomPopUP}
        onClose={() => handleCloseVitalsCustomPopUp("", null)}
        scroll={"paper"}
        PaperProps={{ style: { width: "1200px", maxWidth: "none" } }}
        fullScreen
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography
              style={{ fontWeight: 600, marginLeft: 1 }}
              sx={{ paddingLeft: { xs: 1, sm: 0 } }}
              variant="h6"
            >
              Add to Waiting
            </Typography>
          </Toolbar>
        </AppBar>
        <Divider />
        <DialogContent style={{ height: "relative", padding: "16px" }}>
          <VitalAndAnthropometry
            handleClosePopUp={(code: string, data: any) => {
              handleCloseVitalsCustomPopUp(code, data);
            }}
            opd={opd}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={openBulkTemplateDialog || !!singleSendItem}
        onClose={() => {
          setOpenBulkTemplateDialog(false);
          closeSingleItemTemplateStyleDialog();
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Select Visit Completion Style</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" gutterBottom>
            {singleSendItem
              ? `Please select the template style you want to send to the ${
                  singleSendTarget === "REF_DOCTOR"
                    ? "referral doctor"
                    : "patient"
                }:`
              : "Please select the template style you want to send for this batch:"}
          </Typography>
          <FormControl fullWidth size="small" sx={{ mt: 2 }}>
            <Select
              value={bulkTemplateSelection}
              onChange={(e) => setBulkTemplateSelection(e.target.value)}
            >
              {Object.keys(activeTemplateMap).map((key) => (
                <MenuItem key={key} value={key}>
                  {activeTemplateMap[key].label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={async () => {
              if (singleSendItem) {
                const item = singleSendItem;
                const target = singleSendTarget ?? "PATIENT";
                closeSingleItemTemplateStyleDialog();
                if (target === "REF_DOCTOR") {
                  await sendReferralDoctorViaApi(item, bulkTemplateSelection); // ?? sahi function
                } else {
                  await sendVisitCompletionViaApi(item, bulkTemplateSelection);
                }
                // await sendVisitCompletionViaApi(
                //   item,
                //   bulkTemplateSelection,
                //   target,
                // );
              } else {
                setOpenBulkTemplateDialog(false);
                await handleBulkSend(bulkTemplateSelection);
              }
            }}
            variant="contained"
            color="primary"
          >
            Send Messages
          </Button>
          <Button
            onClick={() => {
              setOpenBulkTemplateDialog(false);
              closeSingleItemTemplateStyleDialog();
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Billing Invoice For A4 HTML */}
      <Dialog
        fullScreen={fullScreen}
        open={openA4HtmlDialog}
        onClose={handleCloseBillingA4HtmlPopup}
        scroll="paper"
        disableEnforceFocus
        disableAutoFocus
        className="print-preview-dialog"
        PaperProps={{
          sx: {
            borderRadius: "4px",
            maxWidth: "950px", // A4 width
            padding: "0px",
            margin: "0px",
            overflow: "hidden",
            backgroundColor: "var(--opd-panel-bg, #fff)",
          },
        }}
      >
        <DialogTitle
          className="print-preview-dialog-title"
          sx={{
            borderBottom: "1px solid var(--opd-border-color, #ddd)",
            padding: "4px 16px",
            backgroundColor: "var(--opd-header-bg, #fff)",
            color: "var(--opd-panel-fg, inherit)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              gap={0}
              sx={{ padding: 0, margin: 0 }}
            >
              {/* Dropdown for selecting zoom level */}
              <Select
                value={zoomLevel}
                onChange={handleZoomChange}
                sx={{
                  mx: 1,
                  minWidth: 70,
                  border: "none",
                  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  backgroundColor: "transparent",
                  padding: 0,
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      border: "1px solid #c7c5c5",
                      borderRadius: "4px",
                    },
                  },
                }}
              >
                {zoomOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    <Typography
                      sx={{
                        fontSize: "13px !important",
                      }}
                    >
                      {(option * 100).toFixed(0)}%
                    </Typography>
                  </MenuItem>
                ))}
              </Select>

              <Box display="flex" gap={1}>
                <Tooltip title="Zoom Out">
                  <IconButton
                    onClick={handleZoomOut}
                    disabled={zoomLevel <= 0.25}
                    sx={{ padding: 0 }}
                  >
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Zoom In">
                  <IconButton
                    onClick={handleZoomIn}
                    disabled={zoomLevel >= 2}
                    sx={{ padding: 0 }}
                  >
                    <AddCircleOutlineIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            <Box display="flex" justifyContent="flex-start" alignItems="center">
              <Tooltip title="Print PDF" placement="top">
                <IconButton aria-label="Print PDF" onClick={handlePdfPrint}>
                  <PrintIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Download PDF" placement="top">
                <IconButton
                  aria-label="Download PDF"
                  onClick={() => handlePDFDownload()}
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip>

              <Box>
                <Tooltip title="Settings" placement="top">
                  <IconButton
                    aria-label="Settings"
                    onClick={(e) => {
                      handleSettingsBillingA4HtmlOpen(e, "BILLING_REPORT");
                    }}
                  >
                    <SettingsIcon />
                  </IconButton>
                </Tooltip>

                <Menu
                  anchorEl={mainMenuEl?.target}
                  open={
                    Boolean(mainMenuEl?.target) &&
                    mainMenuEl?.for === "BILLING_REPORT"
                  }
                >
                  <Box
                    sx={{
                      border: "1px solid #c7c5c5",
                      borderRadius: "4px",
                      backgroundColor: "var(--opd-panel-bg)",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "#dee6fa",
                        color: "#404d54",
                        padding: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      Settings
                    </Box>
                    <Box sx={{ width: "270px" }}>
                      {reportBillingConfigData?.map(
                        (item: any, index: number) => (
                          <MenuItem
                            key={index}
                            sx={{
                              alignItems: "start",
                              paddingLeft: "5px",
                            }}
                            onClick={(e) => {
                              setReportBillingConfigData((prev: any) =>
                                prev.map((x: any) =>
                                  x.configKey === item?.configKey
                                    ? { ...x, isChecked: !item?.isChecked }
                                    : x,
                                ),
                              );
                            }}
                          >
                            <Checkbox
                              checked={item?.isChecked}
                              sx={{
                                padding: 0,
                                margin: 0,
                              }}
                            />
                            <Typography
                              sx={{
                                fontSize: "13px !important",
                                fontWeight: "normal",
                                paddingLeft: "8px",
                              }}
                            >
                              {item?.configKeyLabel}
                            </Typography>
                          </MenuItem>
                        ),
                      )}
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        borderTop: "1px solid #ccc",
                        px: 2,
                        py: 1,
                        gap: "5px",
                      }}
                    >
                      <Button
                        size="small"
                        onClick={handleBillingSettingsSave}
                        color="primary"
                        variant="contained"
                      >
                        Save
                      </Button>
                      <Button
                        onClick={handleSettingsBillingA4HtmlClose}
                        size="small"
                      >
                        Close
                      </Button>
                    </Box>
                  </Box>
                </Menu>
              </Box>

              <Tooltip title="Close" placement="top">
                <IconButton
                  aria-label="close"
                  onClick={handleCloseBillingA4HtmlPopup}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent
          className="print-preview-dialog-content"
          sx={{
            height: "100%",
            padding: "16px !important",
            fontFamily: "Arial, sans-serif",
            backgroundColor: "var(--print-preview-desk, #f1f3f5)",
            boxSizing: "border-box",
          }}
        >
          <Box
            className="print-preview-paper"
            sx={{
              width: "max-content",
              border: "1px solid #ddd",
              boxShadow: "4px rgba(0, 0, 0, 0.2)",
              borderRadius: "2px",
              padding: "30px 50px",
              fontFamily: "Arial, sans-serif",
              backgroundColor: "#ffffff",
              color: "#111111",
              boxSizing: "border-box",
              transform: `scale(${zoomLevel})`,
              transformOrigin: "center",
              transition: "transform 0.2s ease-in-out",
            }}
          >
            <Box ref={htmlprintRef} sx={{ width: "794px" }}>
              <BillingPDFExport
                billingData={detailedBilling}
                selectedSections={billingReportConfigDetail?.reduce(
                  (acc: any, item: any) => {
                    acc[item.configKey] = item.isChecked;
                    return acc;
                  },
                  {},
                )}
              />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* PRESCRIPTION REPORTS BOX */}
      <Dialog
        open={openTemplateDialog}
        onClose={() => setOpenTemplateDialog(false)}
        className="dialogPage"
        fullScreen
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: "800px",
            height: "500px",
            maxWidth: "none",
            borderRadius: "5px",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          className="prescription-template-dialog-title"
          sx={{
            borderBottom: "1px solid var(--opd-border-color, #ddd)",
            padding: "12px 16px",
            backgroundColor: "var(--opd-header-bg, #f8fafc)",
            color: "var(--opd-panel-fg, inherit)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography>Prescription Templates</Typography>
            <Tooltip title="Close" placement="top">
              <IconButton
                aria-label="close"
                onClick={() => setOpenTemplateDialog(false)}
                sx={{ color: "var(--opd-panel-fg, inherit)" }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </DialogTitle>
        <DialogContent
          sx={{
            marginTop: "24px",
          }}
        >
          <PrescriptionTemplateSelection
            templates={
              userContext?.consumerId === 44
                ? PRESCRIPTION_REPORT_TEMPLATES_44
                : PRESCRIPTION_REPORT_TEMPLATES
            }
            defaultTemplate={
              userContext?.defaultPrescriptionTemplate || "Prescription"
            }
            handleTemplateClick={(template: any, closeDialog = true) => {
              handleClickOpenPrescriptionReports(
                "paper",
                selectedOPD,
                template?.value || "",
                closeDialog,
              );
            }}
            setDefaultTemplate={(item: string) => {
              saveDefaultPrescription(item);
              setSelectedPrescriptionTemplate(item || "Prescription");
              handleClickOpenPrescriptionReports(
                "paper",
                selectedOPD,
                item || "",
                true,
              );
            }}
          />
        </DialogContent>
      </Dialog>

      {/* Email Dialog Box */}
      <Dialog
        open={openSendEmailDialog}
        onClose={() => {
          setOpenSendEmailDialog(false);
          setEmailOpd(null);
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Send Email</DialogTitle>
        <Divider />
        <DialogContent>
          <EmailSendDialogForOPD
            onClose={() => {
              setOpenSendEmailDialog(false);
              setEmailOpd(null);
            }}
            opd={emailOpd || selectedOPD}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OPDClinicalDialogs;
